import type { VegaTablePagination } from '@globalpayments/vega/dist/types/components/vega-table/interface';
import { ALL_HORIZON_REGIONS } from '../../types/horizonOptOutTracker';
import type { HorizonOptOutType, HorizonRegion } from '../../types/horizonOptOutTracker';

export const chipColors: Record<
  HorizonRegion | HorizonOptOutType,
  {
    bgColor: 'bg-accent1-primary' | 'bg-accent3-primary' | 'bg-accent8-primary' | 'bg-action';
    textColor: 'text-black' | 'text-white';
  }
> = {
  'Global Payments': { bgColor: 'bg-action', textColor: 'text-white' },
  UK: { bgColor: 'bg-accent3-primary', textColor: 'text-black' },
  US: { bgColor: 'bg-accent1-primary', textColor: 'text-black' },
  Worth: { bgColor: 'bg-accent8-primary', textColor: 'text-white' },
};

export const horizonRegionOptions = [
  { id: ALL_HORIZON_REGIONS, displayName: 'Both regions' },
  { id: 'US', displayName: 'US' },
  { id: 'UK', displayName: 'UK' },
] as const;

export const tablePagination = {
  extensions: [
    ['currentPageLabel', 'pageSizeSelector'],
    ['pageSelector', 'goTo'],
  ],
  pageSize: 10,
  pageSizeSelectorOptions: [10, 25, 50],
  position: 'bottom-right',
} satisfies VegaTablePagination;
